// Counts for the Super Admin's Analytics tab (backend routes/analytics.js): one visit per browser session, and
// clicks on "Get it for free". Also tracks visitor session and when visitors leave or close the website with total time spent.
const SITE = "ownezzy";
const SESSION_KEY = "oz_activity_sid";
const START_TIME_KEY = "oz_session_start";

function storage(kind) {
  try { return window[kind]; } catch { return null; }
}

function getSessionId() {
  const store = storage("sessionStorage");
  let sid = store ? store.getItem(SESSION_KEY) : null;
  if (!sid) {
    sid = "oz_s_" + Math.random().toString(36).slice(2, 10) + "_" + Date.now().toString(36);
    try { store && store.setItem(SESSION_KEY, sid); } catch {}
  }
  return sid;
}

function getSessionStartTime() {
  const store = storage("sessionStorage");
  let start = store ? Number(store.getItem(START_TIME_KEY)) : 0;
  if (!start || isNaN(start)) {
    start = Date.now();
    try { store && store.setItem(START_TIME_KEY, String(start)); } catch {}
  }
  return start;
}

function formatDuration(seconds) {
  const s = Math.max(0, Math.round(Number(seconds) || 0));
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  const remS = s % 60;
  if (m < 60) return remS > 0 ? `${m}m ${remS}s` : `${m}m`;
  const h = Math.floor(m / 60);
  const remM = m % 60;
  return remM > 0 ? `${h}h ${remM}m` : `${h}h`;
}

function sendTrackPayload(events = []) {
  try {
    const body = JSON.stringify({
      sessionId: getSessionId(),
      site: SITE,
      events,
    });
    if (navigator.sendBeacon) {
      const blob = new Blob([body], { type: "application/json" });
      if (navigator.sendBeacon("/api/analytics/track", blob)) return;
    }
    fetch("/api/analytics/track", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body,
      keepalive: true,
    }).catch(() => {});
  } catch {}
}

let lastExitTime = 0;
let lastExitAction = "";

function trackExit(isClose = false) {
  const now = Date.now();
  if (now - lastExitTime < 1200 && (lastExitAction === "closed" || !isClose)) return;
  lastExitTime = now;
  lastExitAction = isClose ? "closed" : "left";

  const start = getSessionStartTime();
  const elapsedSec = Math.max(1, Math.round((now - start) / 1000));
  const timeSpent = formatDuration(elapsedSec);

  const target = isClose
    ? `Closed ownezzy website · Total time spent: ${timeSpent}`
    : `Left ownezzy website · Total time spent: ${timeSpent}`;

  sendTrackPayload([
    {
      type: "site_leave",
      target,
      path: typeof window !== "undefined" ? window.location.pathname : "/",
      meta: {
        action: isClose ? "closed" : "left",
        timeSpent,
        durationSeconds: elapsedSec,
        durationFormatted: timeSpent,
      },
      timestamp: now,
    },
  ]);
}

function send(event) {
  try {
    const body = JSON.stringify({ event, site: SITE });
    if (navigator.sendBeacon) navigator.sendBeacon("/api/analytics/event", new Blob([body], { type: "application/json" }));
    else fetch("/api/analytics/event", { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true }).catch(() => {});
  } catch {
    /* counting must never break the page */
  }
}

export function trackVisit() {
  try {
    if (!sessionStorage.getItem("oz_visit_counted")) {
      sessionStorage.setItem("oz_visit_counted", "1");
      send("visit");
    }
  } catch {
    send("visit");
  }

  // Initialize session tracking & start time
  getSessionStartTime();
  sendTrackPayload([]);

  if (typeof window !== "undefined" && !window.__oz_exit_bound) {
    window.__oz_exit_bound = true;
    window.addEventListener("pagehide", () => trackExit(true));
    window.addEventListener("beforeunload", () => trackExit(true));
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden") {
        trackExit(false);
      } else if (document.visibilityState === "visible") {
        lastExitAction = "";
      }
    });
  }
}

export const trackGetFreeClick = () => send("get_free_click");
